import { render, staticRenderFns } from "./BusinessTile.vue?vue&type=template&id=5f7a8632&scoped=true&"
import script from "./BusinessTile.vue?vue&type=script&lang=ts&"
export * from "./BusinessTile.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessTile.vue?vue&type=style&index=0&id=5f7a8632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a8632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardTitle})
